import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';

export const SearchInputContainer = styled(SuiContainer)`
    border-bottom: 1px solid ${({ theme }) => theme.palette.grayscale.gray10};
`;
